import { useMemo } from "react";
import { useApiContext } from "../components/api/ApiContext";
import RenewalEmailService from "../services/RenewalEmailService";

const useRenewalEmailService = () => {
  const { client } = useApiContext();
  const service = useMemo(() => {
    return new RenewalEmailService(client);
  }, [client]);

  return service;
};

export default useRenewalEmailService;
